module.exports = __webpack_public_path__ + "static/10-1c6f8043e58ecccf04ad216d1408594d.jpg";